import { NationalMenuTileData } from './types';

const dippingSauces: Array<NationalMenuTileData> = [
  {
    id: 'dippingSauce1',
    name: 'Marinara',
    mobileImageUrl: '/images/nationalMenu/dippingSauces/National_Sauces_Marinara.jpg',
    desktopImageUrl: '/images/nationalMenu/dippingSauces/National_Sauces_Marinara.jpg',
    productDescription: 'The stuff of pizza dreams. Our freshly prepared, signature Italian sauce goes great on just about everything.',
    priority: 0,
    vegetarian: false,
    handleClick: () => {}
  },
  {
    id: 'dippingSauce2',
    name: 'Blue Cheese',
    mobileImageUrl: '/images/nationalMenu/dippingSauces/National_Sauces_BlueCheese.jpg',
    desktopImageUrl: '/images/nationalMenu/dippingSauces/National_Sauces_BlueCheese.jpg',
    productDescription: 'Cheese so blue it\'ll put a smile on your face. Add a tangy bite to your wings with this creamy dip.',
    priority: 1,
    vegetarian: false,
    handleClick: () => {}
  },
  {
    id: 'dippingSauce3',
    name: 'Honey BBQ',
    mobileImageUrl: '/images/nationalMenu/dippingSauces/National_Sauces_HoneyBBQ.jpg',
    desktopImageUrl: '/images/nationalMenu/dippingSauces/National_Sauces_HoneyBBQ.jpg',
    productDescription: 'Real honey and molasses make this sweet-and-smoky Honey BBQ sauce the real deal.',
    priority: 2,
    vegetarian: false,
    handleClick: () => {}
  },
  {
    id: 'dippingSauce4',
    name: 'Ranch',
    mobileImageUrl: '/images/nationalMenu/dippingSauces/National_Sauces_Ranch.jpg',
    desktopImageUrl: '/images/nationalMenu/dippingSauces/National_Sauces_Ranch.jpg',
    productDescription: 'Pair your wings or crust (we aren\'t judging!) with this classic cool-and-tangy ranch sauce, made with the perfect blend of herbs and spices.',
    priority: 3,
    vegetarian: false,
    handleClick: () => {}
  },
  {
    id: 'dippingSauce5',
    name: 'Garlic',
    mobileImageUrl: '/images/nationalMenu/dippingSauces/National_Sauces_Garlic.png',
    desktopImageUrl: '/images/nationalMenu/dippingSauces/National_Sauces_Garlic.png',
    productDescription: 'Garlic plus buttery parmesan? Sign us up. Great for dipping wings, crust, stray pepperonis or even just a spoon.',
    priority: 4,
    vegetarian: false,
    handleClick: () => {}
  },
  {
    id: 'dippingSauce6',
    name: 'Icing dip',
    mobileImageUrl: '/images/nationalMenu/dippingSauces/National_Sauces_Icing.png',
    desktopImageUrl: '/images/nationalMenu/dippingSauces/National_Sauces_Icing.png',
    productDescription: 'Sinfully sweet dip! We\'d tell you it\'s just for desserts, but we don\'t want to cramp your creativity.',
    priority: 5,
    vegetarian: false,
    handleClick: () => {}
  }
];

export default dippingSauces;
